import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { orpc } from '@/api/rpc/client';
import type { GetArSyncStatusResponse } from '@erp/rpc';

export function useArSyncStatus() {
  const query = useQuery(
    orpc.accountsReceivable.arSync.getStatus.queryOptions({}),
  );

  const syncStates = query.data?.syncStates ?? [];

  // Find the oldest sync date across all entity types (most conservative "last synced" display)
  const lastSyncAt =
    syncStates.length > 0
      ? syncStates.reduce<Date | null>((oldest, state) => {
          if (!state.lastSyncAt) return oldest;
          if (!oldest) return state.lastSyncAt;
          return state.lastSyncAt < oldest ? state.lastSyncAt : oldest;
        }, null)
      : null;

  const lastSyncDisplay = lastSyncAt
    ? `Last synced: ${format(lastSyncAt, 'MMM d, yyyy h:mm a')}`
    : 'Never synced';

  return {
    ...query,
    lastSyncAt,
    lastSyncDisplay,
  } satisfies typeof query & {
    data?: GetArSyncStatusResponse;
    lastSyncAt: Date | null;
    lastSyncDisplay: string;
  };
}
